// 在应用启动时预加载 Vditor
export default defineNuxtPlugin(async () => {
  // 只在客户端执行
  if (process.client) {
    // 使用 requestIdleCallback 在浏览器空闲时预加载
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        const { warmup } = useVditor()
        warmup()
      })
    } else {
      // 回退到 setTimeout
      setTimeout(() => {
        const { warmup } = useVditor()
        warmup()
      }, 1000)
    }
  }
}) 